import { Button, Form, Modal, Select } from 'antd';
import React, { useEffect, useState } from 'react';
import EventEmitter from '../../utils/eventEmitter';
import { FloatingLabel } from 'flowbite-react';


const MyFooter = ({ handleSaveNew, handleSaveClose, handleCancel }) => {
  return (
    <div className='flex border-t-2 pt-2'>
      <Button className='me-3' onClick={handleSaveNew} type='primary'>Save and New</Button>
      <Button className='me-3' onClick={handleSaveClose} type='primary'>Save and Close</Button>
      <Button onClick={handleCancel} danger>Discard</Button>
    </div>
  )
};
const action = [
  { value: 'pull_from', label: 'Pull From'},
  { value: 'push_to', label: 'Push To'},
  { value: 'pull_push', label: 'Pull & Push' },
  { value: 'buy', label: 'Buy'}
];

const supply_method = [
  { value: 'take_from_stock', label: 'Take From Stock'},
  { value: 'trigger_another_rule', label: 'Trigger Another Rule'},
  { value: 'take_stock_unavailable_trigger_rule', label: 'Take From Stock, if Unavailable, Trigger Another Rule'},
  
];

const RulesModal = ({locations, operations, setRules, rules}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [form] = Form.useForm();
  const [enableSupplyMethod, setEnableSupplyMethod] = useState(false);
  const [name, setName] = useState('');

  const handleCancel = () => setIsModalOpen(false);
  
  const onChangeName = (e) => setName(e.target.value);

  const handleSaveNew = () => {
    // addEntry();
    save();
    
  };

  const addEntry = () => { 
    let rules_ = [...rules]
    let entryObj = {
      key: rules.length + 1,
      name: '',
      action: '',
      operation_type: '',
      destination_location: '',
      source_location: '',
      supply_method: ''
    }
    rules_.push(entryObj);
    form.setFieldsValue({ ...entryObj })
    // setRules(rules_);
  }

  const save = async () => {
    try {
      const row = await form.validateFields();
      let row_ = {...row};
      let rules_ = [...rules];
      let action_ = action.find(item => item.value === row_.action);
      let source_location = locations.find(item => item.id === row_.source_location);
      let destination_location = locations.find(item => item.id === row_.destination_location);
      let operation_type = operations.find(item => item.id === row_.operation_type);
      row_['action'] = action_;
      row_['source_location'] = source_location;
      row_['destination_location'] = destination_location;
      row_['operation_type_id'] = operation_type;
      row_['key'] = rules_.length + 1;
      row_['name'] = name;
      rules_.push(row_);
      setRules(rules_);
      // const newData = [...rules]
      // const index = newData.findIndex((item) => key === item.key)
      // setRules([row])
      // // if (index > -1) {
      // //   const item = newData[index]
      // //   newData.splice(index, 1, { ...item, ...row })
      // //   console.log(newData)
      // //   setRules(newData)
      // // }
    } catch (err) {
      console.log('Validate Failed:', err)
    }
  }

  

  useEffect(() => {
    EventEmitter.subscribe('openRulesModal', data => setIsModalOpen(data));

    EventEmitter.subscribe('openAndEditRulesModal', info => {
      const { open, data } = info;
      setIsModalOpen(open);
      form.setFieldsValue(data);
    });
    return () => {
      EventEmitter.unsubscribe('openRulesModal');
      EventEmitter.unsubscribe('openAndEditRulesModal');
    };
  },[])

  const handleSaveClose = () => {
    save();
    handleCancel();
  }


  const onChange = v => {
    if (v === 'pull_from' || v === 'pull_push') {
      setEnableSupplyMethod(true);
    }else {
      setEnableSupplyMethod(false);
    }
  }

  const onChangeOperation = (v, opt) => {
    form.setFieldValue('source_location', opt.loc_src);
    form.setFieldValue('destination_location', opt.loc_dest);
  }

  return (
    <Modal title="Create Rules" className='p-0 ' open={isModalOpen} onCancel={handleCancel} footer={<MyFooter handleCancel={handleCancel} handleSaveNew={handleSaveNew} handleSaveClose={handleSaveClose}/>}>
      <FloatingLabel
        name='ruleName'
        className='text-2xl'
        variant="standard"
        // disabled={formValue.status!== 'discard' ? true : false}
        label="Rule Name"
        value={name} 
        onChange={onChangeName}
      />
      <Form 
        form={form}
        className='pt-2' 
        labelAlign='left'
        labelCol={{span: 8}}
        initialValues={{  }}
        autoComplete="off"
        variant='borderless'
      >
        <Form.Item label='Action' name="action" className='font-semibold text-gray-800 mb-4' required>
          <Select options={action} onChange={onChange}/>
        </Form.Item>
        <Form.Item label='Operation Type' name="operation_type" className='font-semibold text-gray-800 mb-4' required>
          <Select options={operations.map(operation => ({value: operation.id, label: operation.name, loc_src: operation.source_location, loc_dest: operation.destination_location}))} onChange={onChangeOperation} />
        </Form.Item>
        <Form.Item label='Source Location' name="source_location" className='font-semibold text-gray-800 mb-4' required>
          <Select options={locations.map(location => ({value: location.id, label: `${location.name}`}))} />
        </Form.Item>
        <Form.Item label='Destination Location' name="destination_location" className='font-semibold text-gray-800 mb-4' required>
          <Select options={locations.map(location => ({value: location.id, label: `${location.name}`}))} />
        </Form.Item>
        
        {enableSupplyMethod && <Form.Item label='Supply Method' name="supply_method" className='font-semibold text-gray-800 mb-4' required>
          <Select options={supply_method} />
        </Form.Item>}
      </Form>
    </Modal>
  )
}

export default RulesModal;